import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

import { identifyUser, resetUser } from "../../utils/analytics";
import { useAuth } from "./AuthProvider";

/**
 * PostHog User Provider - Handles user identification for analytics
 * This component ensures PostHog properly identifies users when they log in/out
 */
export function PostHogUserProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, loading } = useAuth();
  const posthog = usePostHog();

  useEffect(() => {
    // Don't do anything while auth is still loading
    if (loading) {
      return;
    }

    if (user) {
      // User is authenticated - identify them in PostHog
      console.log(
        "🔍 PostHogUserProvider: User authenticated, identifying in PostHog",
      );
      identifyUser(posthog, user);
    } else {
      // User is not authenticated - reset PostHog identification
      console.log(
        "🔍 PostHogUserProvider: User not authenticated, resetting PostHog",
      );
      resetUser(posthog);
    }
    posthog.reloadFeatureFlags();
  }, [user, loading, posthog]);

  return children;
}
